import React, { useState } from "react";
import { IconButton, Box, Paper } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ShareIcon from "@mui/icons-material/Share";
import { motion, AnimatePresence } from "framer-motion";

const actions = [
  { icon: <EditIcon />, label: "Edit", onClick: () => alert("Edit clicked") },
  {
    icon: <DeleteIcon />,
    label: "Delete",
    onClick: () => alert("Delete clicked"),
  },
  {
    icon: <ShareIcon />,
    label: "Share",
    onClick: () => alert("Share clicked"),
  },
];

export default function ExpandableActionButtons({ actions }) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <AnimatePresence>
        {open &&
          actions.map((action, index) => (
            <motion.div
              key={`action-${index}`}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -10 }}
              transition={{ delay: index * 0.05 }}
              style={{ marginRight: 8 }}
            >
              {action}
            </motion.div>
          ))}
      </AnimatePresence>

      <IconButton
        size="large"
        color="primary"
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          transition: "transform 0.3s ease",
          transform: open ? "rotate(45deg)" : "rotate(0deg)",
        }}
      >
        <AddIcon />
      </IconButton>
    </Box>
  );
}
